import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { WarehouseForm } from "./WarehouseForm";

export const CreateWarehouseButton = () => {
    const [open, setOpen] = useState(false)
  return <>
    <Button onClick={() => setOpen(true)}>New Warehouse</Button>
    <Modal show={open} onHide={() => setOpen(false)}>
        <WarehouseForm onClose={() => setOpen(false)}/>
    </Modal>
  </>
}